module.exports = __webpack_public_path__ + "img/pdf-icon.38c59267.svg";